// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2j1cL","errorLogs":"EditorFooter_errorLogs__1oBrZ"};